import { dict_match } from 'shared/api/comet/dict-match';
export class Comet {
    api;
    _listeners = {};
    _isActive = false;
    onConnected = null;
    onConnectionLost = null;
    onReloadData = null;
    onAuthError = null;
    constructor(api) {
        this.api = api;
    }
    active() {
        return this._isActive;
    }
    setActive(active) {
        if (active == this._isActive) {
            return;
        }
        this._isActive = active;
        if (active) {
            this.start();
        }
        else {
            this.stop();
        }
    }
    listen(spec) {
        if (!(spec.event in this._listeners)) {
            this._listeners[spec.event] = [];
        }
        this._listeners[spec.event].push(spec);
    }
    listenMany(specs) {
        for (const spec of specs) {
            //@ts-ignore
            this.listen(spec);
        }
    }
    unlisten(spec) {
        const list = this._listeners[spec.event];
        for (let i = list.length - 1; i >= 0; i--) {
            // @ts-ignore
            if (list[i] === spec) {
                list.splice(i, 1);
            }
        }
    }
    // unlistenMany(specs: CometListener[]) {
    //     for (const spec of specs)
    //         this.unlisten(spec);
    // }
    processMessage(msg) {
        if (msg.event === '_comet_session_expired') {
            console.log('Comet session expired, reloading state');
            this.onReloadData?.();
            return this.start();
        }
        const ls = this._listeners[msg.event];
        if (ls == null)
            return;
        for (let i = 0; i < ls.length; i++) {
            const listener = ls[i];
            if (listener.condition && !dict_match(msg, listener.condition))
                continue;
            listener.callback.call(this, msg);
            if (listener.once) {
                ls.splice(i, 1);
                i--;
            }
        }
    }
    generateRandomSerial() {
        return Math.random().toString().substring(2);
    }
    authError() {
        this.onAuthError?.();
        this.setActive(false);
    }
}
